import { DebugValidationResolverMetaKey } from '@framework/validation';
// import asyncMemoizeOne from 'async-memoize-one';
import type { ObjectSchema } from 'yup';
import { yupMemoizedResolver } from './yupMemoizedResolver';

const DEBUG_VALIDATION = false;

export function createYupAugmentedResolver(schema: ObjectSchema<any>) {
  const resolver = yupMemoizedResolver(schema);

  return async (data: any, context: any, options: any) => {
    if (process.env.NODE_ENV === 'test' && process.env.DEBUG_VALIDATION) {
      const result = await resolver(data, context, options);
      console.log('[yupResolver] Validation:', result, 'Data:', data);
    }

    if (process.env.NODE_ENV === 'development') {
      const result = await resolver(data, context, options);
      if (schema.meta()?.[DebugValidationResolverMetaKey] || DEBUG_VALIDATION) {
        console.log('[yupResolver] Validation:', result, 'Data:', data);
      }
    }

    return resolver(data, context, options);
  };
}
